import { IApplicationState } from '../../types/redux';
import { getSellers } from './getSellers';

export function getIsLeadFactory(state: IApplicationState) {
  return getSellers(state).some(seller => seller.isLeadFactory);
}
